import { graphql } from '@/generated/gql';

export const INTAKE_QUOTE_STEP_CREATE_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeQuoteStepCreateMutation($data: SvbrgQuoteDraftInput!) {
    sevenbridges {
      chatSession {
        quote {
          next(data: $data) {
            id
            currency
            quoteReference
            quotedValue
            lineItems {
              description
              earlyDeliveryAt
              id
              lateDeliveryAt
              pricePerUnit
              quantity
              sequence
              title
              unitId
              commodityGroupId
            }
          }
        }
      }
    }
  }
`);
